













import { defineComponent, reactive, ref } from '@vue/composition-api';

import {
  createStockLocation,
  updateStockLocation,
} from '@/api/index';

const CommonModalWithStockLocationEditor = defineComponent({
  setup(props, { emit }) {
    const modal = ref(null);
    const form = reactive({
      id: -1,
      name: '',
      oldName: '',
      call: async () => {
        if (form.id === -1) {
          await createStockLocation({
            name: form.name,
          });
        } else {
          await updateStockLocation(form.id, {
            name: form.name,
          });
        }
        emit('done');
      },
    });

    function open(material = { id: -1, name: '' }) {
      form.id = material.id;
      form.name = material.name;
      form.oldName = material.name;
      (modal.value as any).open();
    }
    function close() {
      form.id = -1;
      form.name = '';
      form.oldName = '';
      (modal.value as any).close();
    }

    return {
      open,
      close,
      form,
      modal,

    };
  },
});

export default CommonModalWithStockLocationEditor;
